export default __webpack_public_path__ + "static/media/prbg.83e850c1.jpg";